import moment from 'moment';
import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey';
import {
  getActiveBalanceZone,
  getActiveCompany,
  getAppConfigurationValue
} from '../../../../redux';
import AxiosInstance from '../../../http-config';

export const apiFetchShips = async (startDate?: Date, endDate?: Date, operationType?: number): Promise<Array<any>> => {
  const company = getActiveCompany()?.id;
  const activeBalanceZone = getActiveBalanceZone()?.id;
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer);
  const initRange = moment(startDate).format('YYYY-MM-DD');
  const endRange = moment(endDate).format('YYYY-MM-DD');
  var serviceUrl = `${apiSuffixUrl}/api/Ships/FetchShips?startDate=${initRange}&endDate=${endRange}&companyId=${company}&balanceZoneId=${activeBalanceZone}`
  if (operationType!=undefined)
  {
    serviceUrl = serviceUrl + `&tipoOperacion=${operationType}`
  }
  return await AxiosInstance.get( serviceUrl
  ).then(response => {
    if (response.data.length > 0) {
      return response.data;
    } else {
      return [];
    }
  });

  //`${process.env.REACT_APP_ODATA_PREFIX}-viajes/oData/Viajes?&$filter=(${filter})&$expand=operaciones($expand=empresa,elementologistico),buque,plantaOrigen,destinos($expand=plantaDestino),comercializadores,propietario`
};

export const apiFetchShipTravel = async (travelId: number): Promise<any> => {
  const company = getActiveCompany()?.id;
  const activeBalanceZone = getActiveBalanceZone()?.id;
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.ApiUrlSuffixPioneer);
  return await AxiosInstance.get(
    // `https://localhost:44368/api/Ships/FetchShipTravel?travelId=${travelId}&companyId=${company}&balanceZoneId=${activeBalanceZone}`
    `${apiSuffixUrl}/api/Ships/FetchShipTravel?travelId=${travelId}&companyId=${company}&balanceZoneId=${activeBalanceZone}`
  ).then(response => {
    if (response.data !== undefined) {
      return response.data;
    } else {
      return undefined;
    }
  });

  //`${process.env.REACT_APP_ODATA_PREFIX}-viajes/oData/Viajes?&$filter=(${filter})&$expand=operaciones($expand=empresa,elementologistico),buque,plantaOrigen,destinos($expand=plantaDestino),comercializadores,propietario`
};
